import Icon from "../Icon";
import Image from "../Image";
import Ratio from "../Ratio";
import React from "react";
import { faUser } from "@fortawesome/free-solid-svg-icons";

export interface ProfileImageProps {
  src?: string;
}

const ProfileImage = ({ src }: ProfileImageProps) => {
  return (
    <Ratio>
      <div className="w-full h-full overflow-hidden bg-gray-200 rounded-full">
        {src ? (
          <Image src={src} />
        ) : (
          <div className="flex items-center justify-center w-full h-full">
            <Icon icon={faUser} />
          </div>
        )}
      </div>
    </Ratio>
  );
};

export default ProfileImage;
